module.exports = __webpack_public_path__ + "img/runnerbondvertical.d0211331.png";